/**
 * Poshaka “benefits” dialog images ship from public/assets/images (CRA static assets).
 * Optional overrides: REACT_APP_POSHAKA_IMAGE1_URL / IMAGE2_URL, or window.__ICCT_POSHAKA_IMAGES__.
 */

const publicPrefix = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');

function publicAsset(relPath) {
  const path = String(relPath || '').startsWith('/') ? String(relPath) : `/${relPath}`;
  return `${publicPrefix}${path}`;
}

const DEFAULT_IMG1 = publicAsset('/assets/images/poshaka-benefit-1.jpg');
const DEFAULT_IMG2 = publicAsset('/assets/images/poshaka-benefit-2.jpg');

export function poshakaBenefitImageUrls() {
  try {
    const w = typeof window !== 'undefined' ? window : null;
    const o = w && w.__ICCT_POSHAKA_IMAGES__;
    if (o && typeof o === 'object') {
      const a = String(o.image1 || o.img1 || '').trim();
      const b = String(o.image2 || o.img2 || '').trim();
      if (a || b) return { img1: a, img2: b };
    }
  } catch {
    /* ignore */
  }

  const e1 = String(process.env.REACT_APP_POSHAKA_IMAGE1_URL || '').trim();
  const e2 = String(process.env.REACT_APP_POSHAKA_IMAGE2_URL || '').trim();

  return {
    img1: e1 || DEFAULT_IMG1,
    img2: e2 || DEFAULT_IMG2,
  };
}
